<section class="sessions-page">
    <header class="sessions-hero">
        <div>
            <span class="section-pill">MINDHELP</span>
            <h1>Mis sesiones</h1>
            <p>Consulta tus sesiones de hoy, próximas solicitudes y el historial de citas finalizadas.</p>
        </div>
        <button mat-button (click)="refresh()" class="refresh-btn">
            <mat-icon>cached</mat-icon>
            Refrescar
        </button>
    </header>

    <mat-tab-group class="sessions-tabs" (selectedTabChange)="changeTab($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Hoy</span>
                <span class="tab-count">{{bookings.length}}</span>
            </ng-template>

            <div class="sessions-loader" *ngIf="loadingToday; else todayContent">
                <span class="sessions-spinner"></span>
                <h2>Cargando sesiones de hoy...</h2>
                <p>Estamos consultando tus citas y solicitudes pendientes.</p>
            </div>

            <ng-template #todayContent>
            <div class="sessions-list" *ngIf="bookings.length > 0; else todayEmpty">
                <article *ngFor="let b of bookings" class="session-card" [ngClass]="getStatusClass(b.status)">
                    <div class="session-main">
                        <div class="session-doctor">
                            <img [src]="getDoctorPhoto(b)" class="session-avatar" (error)="setDefaultPic($event)" alt="avatar">
                            <div>
                                <span class="session-category">{{b.category_name || 'Sesión Mindhelp'}}</span>
                                <h2>{{getDoctorName(b)}}</h2>
                                <p><mat-icon>phone</mat-icon>{{getDoctorPhone(b)}}</p>
                            </div>
                        </div>

                        <span class="status-badge">{{returnStatus(b.status)}}</span>

                        <div class="session-details">
                            <div class="detail-card">
                                <span>Fecha</span>
                                <strong><mat-icon>calendar_today</mat-icon>{{b.start_at | date:'mediumDate'}}</strong>
                            </div>
                            <div class="detail-card">
                                <span>Hora</span>
                                <strong><mat-icon>access_time</mat-icon>{{b.start_at | date:'shortTime'}}</strong>
                            </div>
                            <div class="detail-card">
                                <span>Incluye</span>
                                <strong><mat-icon>groups</mat-icon>Videollamada de 1 hora</strong>
                            </div>
                        </div>

                        <div class="extra-data" *ngIf="b.extra_firstname">
                            <span>Paciente adicional</span>
                            <strong>{{b.extra_firstname}} {{b.extra_lastname || ''}}</strong>
                        </div>
                    </div>

                    <aside class="session-actions">
                        <ng-container *ngIf="b.status === 'to_be_confirmed_by_therapist'; else todaySessionActions">
                            <span class="action-label">Solicitud enviada</span>
                            <h3>Esperando aceptación</h3>
                            <p>El terapeuta debe aceptar la solicitud para confirmar la sesión y habilitar el acceso.</p>
                            <button type="button" class="secondary-action" (click)="showCancel(b, 2)">
                                <mat-icon>close</mat-icon>
                                Cancelar solicitud
                            </button>
                        </ng-container>

                        <ng-template #todaySessionActions>
                            <span class="action-label">Sesión de hoy</span>
                            <h3>Tomar sesión</h3>
                            <p>{{getVideoAccessText(b)}}</p>
                            <button type="button" class="primary-action" [disabled]="!canEnterVideo(b)" (click)="goSession(b)">
                                <mat-icon>videocam</mat-icon>
                                Entrar a video
                            </button>
                        </ng-template>
                    </aside>
                </article>
            </div>

            <ng-template #todayEmpty>
                <div class="empty-state">
                    <mat-icon>event_available</mat-icon>
                    <h2>No tienes sesiones para hoy</h2>
                    <p>Cuando una sesión esté programada para este día, aparecerá aquí aunque esté pendiente de confirmación.</p>
                </div>
            </ng-template>
            </ng-template>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span>Próximas</span>
                <span class="tab-count">{{bookingsUpcoming.length + bookingsToBeCancelled.length}}</span>
            </ng-template>

            <div class="sessions-loader" *ngIf="loadingUpcoming; else upcomingContent">
                <span class="sessions-spinner"></span>
                <h2>Cargando próximas sesiones...</h2>
                <p>Estamos revisando tus citas futuras y solicitudes pendientes.</p>
            </div>

            <ng-template #upcomingContent>
            <div class="sessions-list" *ngIf="(bookingsUpcoming.length + bookingsToBeCancelled.length) > 0; else upcomingEmpty">
                <article *ngFor="let b of bookingsUpcoming" class="session-card" [ngClass]="getStatusClass(b.status)">
                    <div class="session-main">
                        <div class="session-doctor">
                            <img [src]="getDoctorPhoto(b)" class="session-avatar" (error)="setDefaultPic($event)" alt="avatar">
                            <div>
                                <span class="session-category">{{b.category_name || 'Sesión Mindhelp'}}</span>
                                <h2>{{getDoctorName(b)}}</h2>
                            </div>
                        </div>

                        <span class="status-badge">{{returnStatus(b.status)}}</span>

                        <div class="session-details">
                            <div class="detail-card">
                                <span>Fecha</span>
                                <strong><mat-icon>calendar_today</mat-icon>{{b.start_at | date:'mediumDate'}}</strong>
                            </div>
                            <div class="detail-card">
                                <span>Hora</span>
                                <strong><mat-icon>access_time</mat-icon>{{b.start_at | date:'shortTime'}}</strong>
                            </div>
                            <div class="detail-card">
                                <span>Incluye</span>
                                <strong><mat-icon>groups</mat-icon>Videollamada de 1 hora</strong>
                            </div>
                        </div>

                        <div class="extra-data" *ngIf="b.extra_firstname">
                            <span>Paciente adicional</span>
                            <strong>{{b.extra_firstname}} {{b.extra_lastname || ''}}</strong>
                        </div>
                    </div>

                    <aside class="session-actions">
                        <ng-container *ngIf="b.status === 'to_be_confirmed_by_therapist'; else upcomingSessionActions">
                            <span class="action-label">Pendiente del terapeuta</span>
                            <h3>Por confirmar</h3>
                            <p>Gabriel o el terapeuta asignado debe aceptar la solicitud. Mientras tanto, puedes cancelar la solicitud si ya no la necesitas.</p>
                            <button type="button" class="secondary-action" (click)="showCancel(b, 2)">
                                <mat-icon>close</mat-icon>
                                Cancelar solicitud
                            </button>
                        </ng-container>

                        <ng-template #upcomingSessionActions>
                            <span class="action-label">Administrar cita</span>
                            <h3>Reagendar o cancelar</h3>
                            <p>Puedes hacer cambios hasta 24 horas antes de la sesión.</p>
                            <div class="action-row">
                                <button type="button" class="secondary-action" [disabled]="checkReDate(b.start_at)" (click)="reDateBooking(b)">
                                    <mat-icon>event_repeat</mat-icon>
                                    Reagendar
                                </button>
                                <button type="button" class="danger-action" [disabled]="checkReDate(b.start_at)" (click)="showCancel(b)">
                                    <mat-icon>close</mat-icon>
                                    Cancelar
                                </button>
                            </div>
                        </ng-template>
                    </aside>
                </article>

                <article *ngFor="let b of bookingsToBeCancelled" class="session-card status-cancel-pending">
                    <div class="session-main">
                        <div class="session-doctor">
                            <img [src]="getDoctorPhoto(b)" class="session-avatar" (error)="setDefaultPic($event)" alt="avatar">
                            <div>
                                <span class="session-category">{{b.category_name || 'Sesión Mindhelp'}}</span>
                                <h2>{{getDoctorName(b)}}</h2>
                            </div>
                        </div>

                        <span class="status-badge">{{returnStatus(b.status)}}</span>

                        <div class="session-details">
                            <div class="detail-card">
                                <span>Fecha</span>
                                <strong><mat-icon>calendar_today</mat-icon>{{b.start_at | date:'mediumDate'}}</strong>
                            </div>
                            <div class="detail-card">
                                <span>Hora</span>
                                <strong><mat-icon>access_time</mat-icon>{{b.start_at | date:'shortTime'}}</strong>
                            </div>
                            <div class="detail-card">
                                <span>Estado</span>
                                <strong><mat-icon>hourglass_top</mat-icon>Cancelación solicitada</strong>
                            </div>
                        </div>
                    </div>

                    <aside class="session-actions">
                        <span class="action-label">Cancelación en revisión</span>
                        <h3>Solicitud enviada</h3>
                        <p>El terapeuta debe revisar la cancelación. Si tienes dudas, contacta a Médica Móvil o al terapeuta.</p>
                    </aside>
                </article>
            </div>

            <ng-template #upcomingEmpty>
                <div class="empty-state">
                    <mat-icon>event_note</mat-icon>
                    <h2>No tienes próximas sesiones</h2>
                    <p>Cuando agendes una cita futura o esté pendiente de aceptación, aparecerá en esta sección.</p>
                </div>
            </ng-template>
            </ng-template>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span>Finalizadas</span>
                <span class="tab-count">{{bookingsPast.length}}</span>
            </ng-template>

            <div class="sessions-loader" *ngIf="loadingPast; else pastContent">
                <span class="sessions-spinner"></span>
                <h2>Cargando historial...</h2>
                <p>Estamos consultando tus sesiones finalizadas y canceladas.</p>
            </div>

            <ng-template #pastContent>
            <div class="past-grid" *ngIf="bookingsPast.length > 0; else pastEmpty">
                <article *ngFor="let b of bookingsPast" class="past-card" [ngClass]="getStatusClass(b.status)">
                    <div class="session-doctor">
                        <img [src]="getDoctorPhoto(b)" class="session-avatar" (error)="setDefaultPic($event)" alt="avatar">
                        <div>
                            <span class="session-category">{{b.category_name || 'Sesión Mindhelp'}}</span>
                            <h2>{{getDoctorName(b)}}</h2>
                        </div>
                    </div>

                    <span class="status-badge">{{returnStatus(b.status)}}</span>

                    <div class="session-details single-column">
                        <div class="detail-card">
                            <span>Fecha y hora</span>
                            <strong><mat-icon>calendar_today</mat-icon>{{b.start_at | date:'mediumDate'}} · {{b.start_at | date:'shortTime'}}</strong>
                        </div>
                    </div>

                    <button type="button" class="primary-action full-action" [routerLink]="['/panel/booking-now', b.doc_id, b.cat_id]">
                        Volver a agendar
                    </button>
                </article>
            </div>

            <ng-template #pastEmpty>
                <div class="empty-state">
                    <mat-icon>history</mat-icon>
                    <h2>Aún no tienes sesiones finalizadas</h2>
                    <p>Tu historial se mostrará aquí cuando termines o canceles una cita.</p>
                </div>
            </ng-template>

            <button type="button" class="load-more" *ngIf="showGetMore && bookingsPast.length > 0" (click)="getBookingsPast()">
                <span *ngIf="!isLoading">Ver más</span>
                <span *ngIf="isLoading">Cargando...</span>
            </button>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</section>
